import { DatePickerDesignTokens } from '@primeuix/themes/types/datepicker';

export const DATEPICKER_STYLES: DatePickerDesignTokens = {
  panel: {
    padding: '0.625rem',
    borderRadius: '0.375rem',
  },
  header: {
    padding: '0 0 0.375rem 0',
  },
  title: {
    gap: '0.4375rem',
    fontWeight: '500',
  },
  selectMonth: {
    padding: '0.175rem 0.375rem',
  },
  selectYear: {
    padding: '0.175rem 0.375rem',
  },
  dayView: {
    margin: '0.375rem 0 0 0',
  },
  weekDay: {
    padding: '0.175rem',
    fontWeight: '500',
  },
  date: {
    width: '1.75rem',
    height: '1.75rem',
    borderRadius: '50%',
    padding: '0.125rem',
  },
  timePicker: {
    padding: '0.375rem 0 0 0',
    gap: '0.4375rem',
    buttonGap: '0.125rem',
  },
  buttonbar: {
    padding: '0.5rem 0 0 0',
  },
  css: () => `
    .p-datepicker-panel {
      width: 17.5rem;
      font-size: 0.875rem;
    }

    .p-datepicker-panel .p-datepicker-select-month,
    .p-datepicker-panel .p-datepicker-select-year,
    .p-datepicker-panel .p-datepicker-weekday,
    .p-datepicker-panel .p-datepicker-day {
      font-size: 0.875rem;
    }

    .p-datepicker-panel .p-datepicker-prev-button,
    .p-datepicker-panel .p-datepicker-next-button,
    .p-datepicker-panel .p-datepicker-increment-button,
    .p-datepicker-panel .p-datepicker-decrement-button {
      width: 1.75rem !important;
      height: 1.75rem !important;
    }

    .p-datepicker-panel.app-date-time-picker-panel .p-datepicker-time-picker {
      display: none;
    }`,
};
